import { Participante } from './participante.model';
export class MinhaAgenda {
  Id: number;

  // DataInicio : string;
  DataHoraInicio: Date;
  DataFim: string;
  DataHoraFim: Date;
  DataAgendada: string;

  HoraInicio: string;
  HoraInicioAgendada: string;
  HoraFim: string;

  Descricao: string;
  UsuarioId: number;
  UsuarioNome: string;
  UnidadeId: string;
  ExtraUsuarioId: number;
  ClienteId: number;
  ClienteNome: string;
  Status: string;
  EmDestaque: boolean;
  ProcessoId: number;
  ProcessoMovimentacaoId: number;
  Participante: Participante;
  Advogado: Participante;
  UsuarioCancelamentoNome: string;
  UsuarioCriacaoNome: string;
  DataInicioAtendimento: Date;
  DataFimAtendimento: Date;
  DataAtendimentoCancelado: string;
  UsuarioCancelouAtendimentoId: number;
  DataHoraAtendimentoCancelado: Date;

  Cancelado: boolean;
  Audiencia: boolean;
  Realizado: boolean;
  Atendimento: boolean;

  Ativo: boolean;
  Automacao: boolean;

  constructor(descricao: string = '') {
    this.Id = 0;
    this.ExtraUsuarioId = 0;
    this.Descricao = descricao;
    // this.DataAgendada = new Date().toLocaleDateString();
  }
}
